<template>
  <div>
    <AccountPanel title="Lista zamówień">
      <OrdersTable :limit="limit" :offset="(current-1) * limit" />
      <b-pagination align="right" :total-rows="order.count" v-model="current" :per-page="limit"></b-pagination>
    </AccountPanel>
  </div>
</template>


<script>
import OrdersTable from "./OrdersTable.vue";
import { mapState } from "vuex";
import MinusIcon from "vue-material-design-icons/Minus.vue";
import AccountPanel from "./../../account/src/account/AccountPanel.vue";

export default {
  components: {
    OrdersTable,
    AccountPanel
  },
  data() {
    return {
      limit: 20,
      current: 1
    };
  },
  computed: {
    ...mapState({
      order: state => state.order
    })
  },
  methods: {},

  beforeMount() {
    if (!this.$store.state.user.authorizedUser) {
      this.$router.replace({ name: "mainPage" });
    }

    this.$store.dispatch("order/ordersCount");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/order/src/OrdersPage.vue